module.exports = __webpack_public_path__ + "fonts/iconfont.fb8fb1ab.eot";